/**
 * Parallels OrganizationMembershipStatus
 */
export const MEMBERSHIP_STATUS = {
    Pending: 0,
    Active: 1,
    Declined: 2,
    Revoked: 3
};

/**
 * Parallels OrganizationPrivilege
 */
export const ORGANIZATION_PRIVILEGE = {
    Member: 0,
    Admin: 1,
    Owner: 2
};

export function getOrganizationPrivilegeDisplay(roleType) {
    switch (roleType) {
        case ORGANIZATION_PRIVILEGE.Member:
            return "Member";
        case ORGANIZATION_PRIVILEGE.Admin:
            return "Admin";
        case ORGANIZATION_PRIVILEGE.Owner:
            return "Owner";
        default:
            throw `Unrecognized organization privilege: ${roleType}`;
    }
}

export function getOrganizationMembershipStatusDisplay(status) {
    switch (status) {
        case MEMBERSHIP_STATUS.Pending:
            return "Pending";
        case MEMBERSHIP_STATUS.Active:
            return "Active";
        case MEMBERSHIP_STATUS.Declined:
            return "Declined";
        case MEMBERSHIP_STATUS.Revoked:
            return "Revoked";
        default:
            throw `Unrecognized membership status: ${status}`;
    }
}

export function getOrganizationMembershipStatusClass(status) {
    switch (status) {
        case MEMBERSHIP_STATUS.Pending:
            return "text-bubble-warning";
        case MEMBERSHIP_STATUS.Active:
            return "text-bubble-success";
        case MEMBERSHIP_STATUS.Declined:
            return "text-bubble-danger";
        case MEMBERSHIP_STATUS.Revoked:
            return "text-bubble-secondary";
        default:
            throw `Unrecognized membership status: ${status}`;
    }
}
